import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Button,
} from "@mui/material";
import axios from "axios";
import API_BASE_URL from "../config";

const categories = [
  "Jobs",
  "Services",
  "Classifieds",
  "Events",
  "Sponsored Ads",
];

const AdminBookings = () => {
  const [jobs, setJobs] = useState([]);
  const [services, setServices] = useState([]);
  const [classifieds, setClassifieds] = useState([]);
  const [events, setEvents] = useState([]);
  const [sponsoredAds, setSponsoredAds] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Jobs");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        // const res = await axios.get("http://localhost:5000/api/applynowjob");
        const res = await axios.get(`${API_BASE_URL}/applynowjob`);
        console.log("Jobs response:", res.data); // Debug log
        if (Array.isArray(res.data.jobs)) {
          setJobs(res.data.jobs); // Set jobs if it's an array
        } else {
          setJobs([]); // Fallback to empty array if it's not an array
        }
      } catch (error) {
        console.error("Error fetching jobs:", error);
        setJobs([]); // Fallback to empty array in case of error
      }
    };

    const fetchServices = async () => {
      try {
        const res = await axios.get(
          // "http://localhost:5000/api/services/notifications"
          `${API_BASE_URL}/services/notifications`
        );
        console.log("Services response:", res.data); // Debug log
        if (Array.isArray(res.data)) {
          const filtered = res.data.filter(
            (item) => item.opportunity_type === "service"
          );
          setServices(filtered);
        } else {
          setServices([]); // Fallback to empty array if it's not an array
        }
      } catch (error) {
        console.error("Error fetching services:", error);
        setServices([]); // Fallback to empty array in case of error
      }
    };

    const fetchClassifieds = async () => {
      try {
        const res = await axios.get(
          // "http://localhost:5000/api/services/notifications"
          `${API_BASE_URL}/services/notifications`
        );
        console.log("Classifieds response:", res.data); // Debug log
        if (Array.isArray(res.data)) {
          const filtered = res.data.filter(
            (item) => item.opportunity_type === "classifieds"
          );
          setClassifieds(filtered);
        } else {
          setClassifieds([]); // Fallback to empty array if it's not an array
        }
      } catch (error) {
        console.error("Error fetching classifieds:", error);
        setClassifieds([]); // Fallback to empty array in case of error
      }
    };

    const fetchEvents = async () => {
      try {
        // const res = await axios.get("http://localhost:5000/api/booktickets");
        const res = await axios.get(`${API_BASE_URL}/booktickets`);
        console.log("Events response:", res.data); // Debug log
        if (Array.isArray(res.data)) {
          setEvents(res.data);
        } else {
          setEvents([]); // Fallback to empty array if it's not an array
        }
      } catch (error) {
        console.error("Error fetching events:", error);
        setEvents([]); // Fallback to empty array in case of error
      }
    };

    const fetchSponsoredAds = async () => {
      try {
        // const res = await axios.get("http://localhost:5000/api/sponsored-ads");
        const res = await axios.get(`${API_BASE_URL}/sponsored-ads`);
        console.log("Sponsored Ads response:", res.data); // Debug log
        if (Array.isArray(res.data.ad)) {
          setSponsoredAds(res.data.ad);
        } else {
          setSponsoredAds([]); // Fallback to empty array if it's not an array
        }
      } catch (error) {
        console.error("Error fetching sponsored ads:", error);
        setSponsoredAds([]); // Fallback to empty array in case of error
      }
    };

    const fetchAll = async () => {
      setLoading(true);
      await Promise.all([
        fetchJobs(),
        fetchServices(),
        fetchClassifieds(),
        fetchEvents(),
        fetchSponsoredAds(),
      ]);
      setLoading(false);
    };

    fetchAll();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 5,mb:4 }}>
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        mb={3}
        color="#42326e"
      >
        All Bookings
      </Typography>

      <Grid container spacing={2} justifyContent="center" mb={3}>
        {categories.map((category) => (
          <Grid item key={category}>
            <Button
              variant={selectedCategory === category ? "contained" : "outlined"}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </Button>
          </Grid>
        ))}
      </Grid>

      {loading ? (
        <CircularProgress sx={{ display: "block", margin: "auto" }} />
      ) : (
        <>
          {selectedCategory === "Jobs" && (
            <>
              <Typography
                variant="h5"
                color="secondary"
                fontWeight="bold"
                textAlign="center"
                mt={5}
                mb={2}
              >
                Jobs
              </Typography>

              {Array.isArray(jobs) && jobs.length > 0 ? (
                <Grid container spacing={3}>
                  {jobs.map((job) => (
                    <Grid item xs={12} sm={6} md={4} key={job.id}>
                      <Card sx={{ boxShadow: 3, p: 2 }}>
                        <CardContent>
                          <Typography variant="h6" fontWeight="bold">
                            Job Title: {job.job_title}
                          </Typography>
                          <Typography>Experience: {job.experience}</Typography>
                          <Typography>
                            Applied on:{" "}
                            {new Date(job.applied_at).toLocaleDateString()}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography textAlign="center" color="textSecondary">
                  No jobs found.
                </Typography>
              )}
            </>
          )}

          {selectedCategory === "Services" && (
            <>
              <Typography
                variant="h5"
                color="secondary"
                fontWeight="bold"
                textAlign="center"
                mt={5}
                mb={2}
              >
                Services
              </Typography>
              {Array.isArray(services) && services.length === 0 ? (
                <Typography textAlign="center" color="textSecondary">
                  No Services available.
                </Typography>
              ) : (
                <Grid container spacing={3}>
                  {services.map((item) => (
                    <Grid item xs={12} sm={6} md={4} key={item.id}>
                      <Card sx={{ boxShadow: 3, p: 2 }}>
                        <CardContent>
                          <Typography variant="h6" fontWeight="bold">
                            {item.message2}
                          </Typography>
                          <Typography>{item.response}</Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
            </>
          )}

          {selectedCategory === "Classifieds" && (
            <>
              <Typography
                variant="h5"
                color="secondary"
                fontWeight="bold"
                textAlign="center"
                mt={5}
                mb={2}
              >
                Classified Ads
              </Typography>
              {Array.isArray(classifieds) && classifieds.length === 0 ? (
                <Typography textAlign="center" color="textSecondary">
                  No Classified Ads available.
                </Typography>
              ) : (
                <Grid container spacing={3}>
                  {classifieds.map((item) => (
                    <Grid item xs={12} sm={6} md={4} key={item.id}>
                      <Card sx={{ boxShadow: 3, p: 2 }}>
                        <CardContent>
                          <Typography variant="h6" fontWeight="bold">
                            {item.message2}
                          </Typography>
                          <Typography>{item.response}</Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
            </>
          )}

          {selectedCategory === "Events" && (
            <>
              <Typography
                variant="h5"
                color="secondary"
                fontWeight="bold"
                textAlign="center"
                mt={5}
                mb={2}
              >
                Events
              </Typography>
              {Array.isArray(events) && events.length === 0 ? (
                <Typography textAlign="center" color="textSecondary">
                  No Events available.
                </Typography>
              ) : (
                <Grid container spacing={3}>
                  {events.map((item) => (
                    <Grid item xs={12} sm={6} md={4} key={item.id}>
                      <Card sx={{ boxShadow: 3, p: 2 }}>
                        <CardContent>
                          <Typography variant="h6" fontWeight="bold">
                            Event Title: {item.title}
                          </Typography>
                          <Typography>
                            Description: {item.description}
                          </Typography>
                          <Typography>
                            Date: {new Date(item.date).toLocaleDateString()}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
            </>
          )}

          {selectedCategory === "Sponsored Ads" && (
            <>
              <Typography
                variant="h5"
                color="secondary"
                fontWeight="bold"
                textAlign="center"
                mt={5}
                mb={2}
              >
                Sponsored Ads
              </Typography>

              {Array.isArray(sponsoredAds) && sponsoredAds.length === 0 ? (
                <Typography textAlign="center" color="textSecondary">
                  No Sponsored Ads available.
                </Typography>
              ) : (
                <Grid container spacing={3}>
                  {sponsoredAds.map((ad) => (
                    <Grid item xs={12} sm={6} md={4} key={ad.id}>
                      <Card sx={{ boxShadow: 3, p: 2 }}>
                        <CardContent>
                          <Typography variant="h6" fontWeight="bold">
                            Ad Title: {ad.title}
                          </Typography>
                          <Typography>Business Name: {ad.business}</Typography>
                          <Typography>Price : {ad.price}</Typography>
                          <Typography>Category: {ad.category}</Typography>
                          <Typography>Description: {ad.description}</Typography>
                          <Typography>Location: {ad.location}</Typography>
                          <Typography>
                            Date: {new Date(ad.created_at).toLocaleDateString()}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
            </>
          )}
        </>
      )}
    </Container>
  );
};

export default AdminBookings;
